import { render, staticRenderFns } from "./SMarks.vue?vue&type=template&id=f14c88f6&scoped=true"
import script from "./SMarks.vue?vue&type=script&lang=js"
export * from "./SMarks.vue?vue&type=script&lang=js"
import style0 from "./SMarks.vue?vue&type=style&index=0&id=f14c88f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14c88f6",
  null
  
)

export default component.exports